// Lines My profile shows, kept out of the component so they can be tested on their own.
import { copy } from '../auth/copy';
import type { Role } from '../roles';

const monthDay = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York',
  month: 'short',
  day: 'numeric',
});

/** "Dec 12", as the kit writes dates in lists and lines. */
export const shortDate = (iso: string) => monthDay.format(new Date(iso));

/** Who changes this person's name and role. The Admin has no one above them, so no line. */
export function managedBy(role: Role): string | null {
  if (role === 'Admin') return null;
  return role === 'Manager' ? copy.managedByAdmin : copy.managedByManager;
}
